import React, { useEffect, useRef, useState } from 'react'
import { Container, Top } from '../../styles'
import {
  FileButton,
  Description,
  Title,
  ContainerUploadFiles,
  SubBoxContainerUploadFiles,
  ImgLogo,
  ButtonsControl
} from './styles'

import { DefaultAdminPage } from '../../../DefaultPages'
import {
  BoxContainer,
  Breadcrumbs,
  Button,
  InsideFooter,
  Tab,
  Typography
} from '../../../../components'
import { useModal } from '../../../../hooks/useModal'

import { CertificateDetailsTabs } from '../../../../constants/order'
import ecbrApi from '../../../../services/ecbrApi'
import useUrlParam from '../../../../hooks/useUrlParam'
import { ECBR_DNA_API } from '../../../../envConfig'
import { downloadImage } from '../../../../utils/downloadImage'
import CertificateImageModal from './CertificateImageModal'
import Pricing from './Pricing'

const CertificateDetails = () => {
  const [renderModal, openModal] = useModal(CertificateImageModal)
  const [tabName, setTabName] = useState(
    CertificateDetailsTabs.CERTIFICATION_PRICE
  )
  const [productId] = useUrlParam('/admin/certificates/:id')
  const [image, setImage] = useState({})
  const [_productName, setProductName] = useState('')

  const requestData = async () => {
    const { data } = await ecbrApi.products.getById(productId)

    setImage(data.imageId)
    setProductName(data.name)
  }

  useEffect(() => {
    requestData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const plusEl = useRef(null)

  const onButtonClick = (isPlus) => {
    if (isPlus) {
      openModal({ onExited: () => requestData() })
    } else {
      downloadImage(`${ECBR_DNA_API}/files/${image}`, 'imagem_certificado.png')
    }
  }

  return (
    <DefaultAdminPage page="certificados">
      <Container>
        {renderModal}
        <Breadcrumbs />
        <Description>
          Aqui você pode gerenciar todas as certificações
        </Description>
        <Tab>
          {/* <Tab.Item
            name="tabName"
            label="Certificação"
            onClick={() => setTabName(CertificateDetailsTabs.CERTIFICATION_ITEM)}
            checked={tabName === CertificateDetailsTabs.CERTIFICATION_ITEM}
          /> */}
          <Tab.Item
            name="tabName"
            label="Precificação"
            onClick={() =>
              setTabName(CertificateDetailsTabs.CERTIFICATION_PRICE)
            }
            checked={tabName === CertificateDetailsTabs.CERTIFICATION_PRICE}
          />
          <Tab.Item
            name="tabName"
            label="Arquivos"
            onClick={() =>
              setTabName(CertificateDetailsTabs.CERTIFICATION_FILES)
            }
            checked={tabName === CertificateDetailsTabs.CERTIFICATION_FILES}
          />
        </Tab>

        {tabName === CertificateDetailsTabs.CERTIFICATION_PRICE && <Pricing />}
        {tabName === CertificateDetailsTabs.CERTIFICATION_FILES && (
          <>
            <Top>
              <Title>Upload da imagem do certificado</Title>
            </Top>
            <ContainerUploadFiles className={`${image ? 'fitContainer' : ''}`}>
              <BoxContainer>
                {!image && (
                  <>
                    <Typography
                      color="gray"
                      size="small"
                      onClick={() => onButtonClick(true)}
                    >
                      Nenhuma imagem cadastrada para o certificado.{' '}
                      <span className="underline">Clique aqui</span> para enviar
                      uma imagem.
                    </Typography>
                    <FileButton ref={plusEl} type="file" onChange={() => {}} />
                  </>
                )}
                {image && (
                  <>
                    <SubBoxContainerUploadFiles>
                      <ImgLogo src={`${ECBR_DNA_API}/files/${image}`} />
                    </SubBoxContainerUploadFiles>
                    <FileButton ref={plusEl} type="file" onChange={() => {}} />
                  </>
                )}
                {image && (
                  <>
                    <ButtonsControl>
                      <Button
                        text="Baixar"
                        variant="outlined"
                        width="125px"
                        onClick={() => onButtonClick(false)}
                      />
                      <Button
                        text="Alterar imagem"
                        variant="outlined"
                        width="125px"
                        onClick={() => onButtonClick(true)}
                      />
                    </ButtonsControl>
                  </>
                )}
              </BoxContainer>
            </ContainerUploadFiles>
          </>
        )}

        <InsideFooter />
      </Container>
    </DefaultAdminPage>
  )
}

export default CertificateDetails
